"use strict";

module.exports = function(config, get){
	return {
		getWeather: getWeather
	};

	function getWeather(ip){
		return get("/v2/weather", {
			ip: ip
		});
	}
};